import InputView from "./input_view";

class EditableInputView extends InputView {
  constructor(options) {
    super(options);

    if (!this.options.attr || !this.options.model) {
      throw new Error("attr and model are required for filter components");
    }
    this.attr = this.options.attr;
    this.model = this.options.model;
  }

  beforeRender() {
    throw new Error("must be implemented by subclass");
  }

  afterRender() {
    this._initBindings();
  }
}

export default EditableInputView;
